import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { assetsRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsRoute.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { landingPageEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-cmdb-landing-page/src/entrypoint.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import { fg } from '@atlassian/jira-feature-gating';
import { ConditionalAssetsPage } from './ui/ConditionalAssetsPage.tsx';

const assetsPageEntryPoint = createChromelessEntryPoint({
	main: landingPageEntryPoint,
});

export const assetsRouteEntry = createEntry(assetsRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: Spinner,

	// Use component for conditional redirect when feature gate is enabled
	component: componentWithFG('assets_for_you', ConditionalAssetsPage, () => null),

	// Only use entryPoint when feature gate is disabled
	entryPoint: () => (fg('assets_for_you') ? undefined : assetsPageEntryPoint),

	pageId: () => 'spa-apps/servicedesk/insight/cmdb-landing-page',
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',
	ufoName: 'assets-app-schemas-page',

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsRouteEntry.tsx',
			whichExportToUse: 'assetsRouteEntry',
		},

		enabled: true,
	},
}));
